<template>
  <div id="welcome" class="welcome">
    <h2>Welcome to Click &lsquo;em Quick!</h2>
    <p>Before you can begin, please create a Gamertag.</p>
    <p>This is your publicly visible ID (display name).</p>
    <form @submit.prevent="saveGamertag" @keydown.enter.prevent>
      <div class="form-row-wrapper">
        <div class="form-row">
          <label for="gamerTag"
            >Gamertag <span class="num-chars-left">{{ numCharsLeftMessage }}</span></label
          >
          <input id="gamerTag" type="text" v-model="gamerTag" @input="gamerTagInput" :maxlength="gamerTagMaxLength" required />
        </div>
      </div>
      <button type="submit">Save gamertag</button>
    </form>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db from './../firebaseInit';
import logUserActivity from './../helpers/logUserActivity';
import {VIEWED_WELCOME_SCREEN, CREATED_GAMERTAG} from './../constants/activityLogs';
import {createNamespacedHelpers} from 'vuex';
import {GAMERTAG_MAX_LENGTH} from './../constants/globalConstants';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'welcome',
  title: 'Welcome',
  data: function() {
    return {
      gamerTag: 0,
      gamerTagMaxLength: 0,
    };
  },
  computed: {
    ...userVuexModule.mapGetters(['getGamerTag']),
    numCharsLeftMessage: function() {
      if (this.gamerTag.length === 0) {
        return `(${this.gamerTagMaxLength} chars)`;
      } else {
        return `(${this.gamerTagMaxLength - this.gamerTag.length} chars left)`;
      }
    },
  },
  created() {
    this.currentUser = firebase.auth().currentUser;
    this.gamerTagMaxLength = GAMERTAG_MAX_LENGTH;
    this.gamerTag = this.getGamerTag;
  },
  methods: {
    gamerTagInput({type, target}) {
      this.gamerTag = target.value.replace(/[^a-z0-9_]/gi, '');
    },
    saveGamertag: function() {
      this.$store.dispatch('userVuexModule/SET_GAMERTAG_ACTION', {
        gamerTag: this.gamerTag,
      });
      this.$router.push('/dashboard');
    },
  },
};
</script>

<style lang="scss" scoped>
.num-chars-left {
  color: var(--color-grey-4);
}
</style>
